/**
 * function to insert custom roll size logic
 * to each quantity input
 */

function initCustomRolQuantityLogic () {
  if (window.AVI && window.AVI.customRollItems && window.AVI.customRollItems.inCart) {
    var itemsInCart = window.AVI.customRollItems.inCart
    itemsInCart.forEach(hideCustomRollQuantity)
  }
}

/**
 * function to disable quantity input
 * logic if the line item is custom roll size
 */

function hideCustomRollQuantity (customItem) {
  var quantityInput = document.querySelector('a[aria-label="Remove ' + customItem.title + '"]')
  
  var quntityInputParent = quantityInput && quantityInput.closest('.cart-item')
  if (quntityInputParent) {
    var buttonsToDisable = quntityInputParent.querySelectorAll('button')
    var inputsToDisable = quntityInputParent.querySelectorAll('input')
    buttonsToDisable.forEach(buttonElement => buttonElement.disabled = true)
    inputsToDisable.forEach(inputElement => inputElement.disabled = true)
    quntityInputParent.classList.add('custom')
  }
}

initCustomRolQuantityLogic()

document.addEventListener("DOMContentLoaded", function () {
    var cartItems = document.querySelector('.js-contents')
    if (cartItems) {
      var observer = new MutationObserver(function (mutations) {
window.initCustomRolQuantityLogic()
      })
      observer.observe(cartItems, { attributes: false, childList: true, characterData: false, subtree: false })
    } 
})